<template>
    <tbody :class="{ 'CostableTableGroupDraggable' : !isOtherCosts }">

        <CostableTableGroupHeading
            v-if="isOtherCosts ? hasCostGroups : true"
            :group="group"
            :expanded="expanded"
            @toggleExpanded="toggleExpanded"
        />

        <CostableTableGroupCosts
            v-if="expanded || (isOtherCosts && !hasCostGroups)"
            :group="group"
        />

        <CostableTableGroupTotals
            v-if="expanded && (isOtherCosts ? hasCostGroups : true)"
            :group="group"
        />

    </tbody>
</template>

<script>
import CostableTableGroupHeading from './CostableTableGroupHeading';
import CostableTableGroupCosts from './CostableTableGroupCosts';
import CostableTableGroupTotals from './CostableTableGroupTotals';

export default {

    components: {
        CostableTableGroupHeading,
        CostableTableGroupCosts,
        CostableTableGroupTotals,
    },

    props: {
        group: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            expanded: false,
        };
    },

    computed: {
        isOtherCosts() {
            return !this.group.id;
        },
        hasCostGroups() {
            return this.$store.getters['costable/hasCostGroups'];
        },
    },

    mounted() {
        this.expanded = this.group.expanded;
    },

    methods: {
        toggleExpanded() {
            this.expanded = !this.expanded;
        },
    },

};
</script>
